<template>
    <div class="content_box nopadding mobile_content">
        <div class="top fixed_top el_form">
            <div class="title">
                <span>扫地机设备运营报表</span> &nbsp;&nbsp;
                <el-select v-model="getTrendData.productKey" clearable size="medium" placeholder="产品型号">
                    <el-option :label="item.name" :value="item.productKey" v-for="item in productTypes" :key="item.productKey + '22123'"></el-option>
                </el-select>
            </div>
            <el-select v-model="region" placeholder="请选择" class="region-select" @change="regionChanged">
                <el-option label="全部区域" value=""></el-option>
                <el-option label="美洲数据中心" value="us"></el-option>
                <el-option label="中国数据中心" value="cn"></el-option>
                <el-option label="欧洲数据中心" value="eu"></el-option>
                <el-option label="亚太数据中心" value="ap"></el-option>
            </el-select>
        </div>
        <div class="area">
            <div class="content device-operation">
                <div class="overview">
                    <div class="title subtitle mobile_form">
                        <span>概况</span>
                        <el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
                            <div slot="content">
                                <el-form label-position="left" label-width="150px">
                                    <el-form-item :label="item.name" v-for="(item, index) in overviewTip" :key="item.id + 123">
                                        <span>{{item.desc}}</span>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <img class="icon-tip" v-if="$store.state.type == 'pc'" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                        </el-tooltip>
                    </div>
                    <div class="time">{{'数据时间 ' + formDate((new Date()).getTime(),'YYYY-MM-DD HH:mm')}}</div>
                    <div class="overview_box">
                        <div class="overview_area">
                            <div class="overview_item" v-for="(item, index) in overviewTip.slice(0,6)" :key="item.id + 443">
                                <p class="name">{{item.name}}</p>
                                <p class="number">{{formatNumber(overviewData[item.key] || 0)}}</p>
                                <p class="compared" v-if="index < 4">
                                    <span>昨日同期</span> &nbsp;
                                    <span class="num" :class="overviewData[item.rate] > 0 ? 'num2' : (overviewData[item.rate] < 0 ? 'num3' : '')">{{overviewData[item.rate] ?  overviewData[item.rate] + '%' : '-'}}</span>
                                    <img class="ico" v-if="overviewData[item.rate] < 0" src="../../../assets/images/ico/down.png" alt="">
                                    <img class="ico" v-if="overviewData[item.rate] > 0" src="../../../assets/images/ico/up.png" alt="">
                                </p>
                                <p class="compared" v-if="item.id == 15">
                                    <span>在线占比 </span> &nbsp;
                                    <span class="num online">{{(overviewData.run_sum_all && overviewData.run_sum_all > 0) ? ((overviewData.online_count || 0)/overviewData.run_sum_all * 100).toFixed(2) + '%' : '--'}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="overview_area overview_area_1">
                            <div class="device_area_1">
                                <div class="overview_title">设备数</div>
                                <div class="overview_item" v-for="(item, index) in overviewTip.slice(6,9)" :key="item.id + 567">
                                    <p class="name">{{item.name}}</p>
                                    <p class="number">{{formatNumber(overviewData[item.key] || 0)}}</p>
                                </div>
                            </div>
                            <div class="device_area_2">
                                <div class="overview_title">清扫面积(㎡)</div>
                                <div class="overview_item" v-for="(item, index) in overviewTip.slice(9,12)" :key="item.id + 789">
                                    <p class="name">{{item.name}}</p>
                                    <p class="number">{{formatNumber(overviewData[item.key] || 0)}}</p>
                                </div>
                            </div>
                            <div class="device_area_3">
                                <div class="overview_title">清扫时长(小时)</div>
                                <div class="overview_item" v-for="(item, index) in overviewTip.slice(12,15)" :key="item.id + 678">
                                    <p class="name">{{item.name}}</p>
                                    <p class="number">{{formatNumber(overviewData[item.key] || 0)}}</p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="trend">
                    <div class="trend_box">
                        <div class="top padding">
                            <div class="title subtitle">
                                <span>历史趋势</span>
                            </div>
                            <div class="search_box">
                                <el-form label-position="left" :label-width="$store.state.type == 'pc' ? '100px' : '80px'">
                                    <el-form-item label="统计指标">
                                        <el-radio-group v-model="trendType" size="small" v-if="$store.state.type == 'pc'">
                                            <el-radio-button label="create">激活设备数</el-radio-button>
                                            <el-radio-button label="active">活跃设备数</el-radio-button>
                                            <el-radio-button label="area">清扫面积(㎡)</el-radio-button>
                                            <el-radio-button label="hours">清扫时长(小时)</el-radio-button>
                                        </el-radio-group>
                                        <el-radio-group v-model="trendType" size="small" v-if="$store.state.type == 'mobile'">
                                            <el-radio-button label="create">激活设备数</el-radio-button>
                                            <el-radio-button label="active">活跃设备数</el-radio-button>
                                        </el-radio-group>
                                        <el-radio-group v-model="trendType" size="small" v-if="$store.state.type == 'mobile'">
                                            <el-radio-button label="area">清扫面积(㎡)</el-radio-button>
                                            <el-radio-button label="hours">清扫时长(小时)</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="日期选择">
                                        <DatePicker :date="trendTime" max="120" @dateSelect="dateSelect"></DatePicker>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                        <div class="line"></div>
                        <div class="padding line_echart">
                            <div class="select_show_type">
                                <el-radio-group v-model="getTrendData.data_type" size="small">
                                    <el-radio-button label="TypeDay">日</el-radio-button>
                                    <el-radio-button label="TypeWeek" :disabled="!(selectType > 1)">周</el-radio-button>
                                    <el-radio-button label="TypeMonth" :disabled="!(selectType > 2)">月</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="echart_line_area data_area">
                                <div class="line_box" ref="line_echart">

                                </div>
                                <div class="dataNone line_none" v-show="this.trendData.length == 0">暂无数据</div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="trend">
                    <div class="padding trend_table">
                        <div class="title subtitle title-1">
                            <span>数据明细</span>
                        </div>
                        <div class="line"></div>
                        <el-table
                            highlight-current-row
                            :data="trendTableData">
                            <el-table-column prop="time_info" label="日期" min-width="90px"></el-table-column>
                            <el-table-column prop="create" label="激活设备数" >
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.create)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="active" label="活跃设备数" >
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.active)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="area" label="清扫面积（m²）" min-width="120px">
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.area)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="hours" label="清扫时长（小时）" min-width="120px" >
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.hours)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <Pagination :total="this.trendData.length" :page="page" @paginationChange="initTableData"></Pagination>
                    </div>  
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import resize  from "../../../minxins/resize"
export default({
    name: 'device-operation',
    mixins: [resize],
    data() {
        return {
            region: '',
            overviewTip: [
                {
                    id: '1',
                    name: '今日激活设备',
                    desc: '今日新增的扫地机器人激活设备数',
                    key: 'run_count',
                    rate: 'run_rate'
                },{
                    id: '2',
                    name: '今日活跃设备',
                    desc: '今日启动过的扫地机器人设备数',
                    key: 'active_count',
                    rate: 'active_rate'
                },{
                    id: '3',
                    name: '今日清扫面积(㎡)',
                    desc: '今日扫地机的总清扫面积',
                    key: 'area_sum',
                    rate: 'area_rate'
                },{
                    id: '4',
                    name: '今日清扫时长(小时)',
                    desc: '今日扫地机的总清扫时长',
                    key: 'time_sum',
                    rate: 'time_rate'
                },{
                    id: '15',
                    name: '当前在线设备数',
                    desc: '截止至当前时间，扫地机在线设备数',
                    key: 'online_count',
                    rate: 'run_rate'
                },{
                    id: '14',
                    name: '近30天未清扫设备数',
                    desc: '截止至当前时间，最近30天未产生清扫数据的设备数',
                    key: 'no_clean',
                },{
                    id: '5',
                    name: '累计激活设备',
                    desc: '截止到当前时间，已联网激活的扫地机设备总数',
                    key: 'run_sum_all'
                },{
                    id: '12',
                    name: '激活设备（7日平均）',
                    desc: '最近7日（不含今日）每日激活设备的平均值',
                    key: 'run_avg_week'
                },{
                    id: '13',
                    name: '活跃设备（7日平均)',
                    desc: '最近7日（不含今日）每日活跃设备的平均值',
                    key: 'active_avg_week'
                },{
                    id: '6',
                    name: '累计清扫面积',
                    desc: '截止到当前时间，所有扫地机设备的总清扫面积',
                    key: 'area_sum_all'
                },{
                    id: '8',
                    name: '清扫面积中位数',
                    desc: '截止到当前时间，所有扫地机设备清扫时长的中位数',
                    key: 'area_median'
                },{
                    id: '9',
                    name: '平均清扫面积',
                    desc: '截止到当前时间，所有扫地机设备清扫面积的平均数',
                    key: 'area_avg'
                },{
                    id: '7',
                    name: '累计清扫时长',
                    desc: '截止到当前时间，所有扫地机设备的总清扫时长',
                    key: 'time_sum_all'
                },{
                    id: '10',
                    name: '清扫时长中位数',
                    desc: '截止到当前时间，所有扫地机设备清扫时长的中位数',
                    key: 'time_median'
                },{
                    id: '11',
                    name: '平均清扫时长',
                    desc: '截止到当前时间，所有扫地机设备清扫时长的平均数',
                    key: 'time_avg'
                }
            ],
            overviewData: {},
            trendTime: [],
            trendType: 'create',
            trendLabel: {
                create: '激活设备数',
                active: '活跃设备数',
                area: '清扫面积(㎡)',
                hours: '清扫时长(小时)'
            },
            selectType: 3,
            productTypes: [],
            getTrendData: {
                start_time: 0,
                end_time: 0,
                data_type: 'TypeDay',
                productKey: ''
            },
            trendData: {},
            trendTableData: [],
            page_size: 10,
            page: 1,
            total: 0
        }
    },
    watch: {
        'getTrendData.productKey': function() {
            this.getDeviceData();
        },
        'getTrendData': {
            handler (nD, oD) {
                this.getDeviceTrend();
            },
            deep: true
        },
        'trendTime' : function (nTime, oTime) {
            if(nTime[1] - nTime[0] < 86400000 * 7) { //选择7天内 
                this.selectType = 1;
                this.getTrendData.data_type = 'TypeDay';
            }else if(nTime[1] - nTime[0] < 86400000 * 30) { //选择30天内 
                this.selectType = 2;
                if(this.getTrendData.data_type == 'TypeMonth') {
                    this.getTrendData.data_type = 'TypeWeek';
                }
            }else{
                this.selectType = 3;
            }
            this.getTrendData.start_time = this.formDate(nTime[0], 'YYYY-MM-DD');
            this.getTrendData.end_time = this.formDate(nTime[1], 'YYYY-MM-DD');
        },
        trendType: function() {
            this.initLine();
        }
    },
    created() {
        this.region = this.$route.query.region || this.region;
        this.getProductList();
        this.getDeviceData();
        this.trendTime = this.setDate(30);
    },
    methods: {
        regionChanged(val) {
            this.region = val;
            this.$router.replace('?region=' + val);
            this.total = 0;
            this.overviewData = {};
            this.trendData = {};
            this.getDeviceData();
            this.getDeviceTrend();
        },
        getProductList() {
            this.api.getIotProductList({}).then(data => {
                this.productTypes = [{name: '全部产品', productKey: ''} ,...data.data.result];;
                
            })
        },
        getDeviceData() {
            this.api.getDeviceData({productKey: this.getTrendData.productKey}).then(data => {
                this.overviewData = data.data.result;
            })
        },
        getDeviceTrend() {
            this.api.getDeviceTrend(this.getTrendData).then(data => {
                this.trendData = data.data.data_list;
                this.initLine();
                this.initTableData({page_size: this.page_size, page: 1});
            })
        },
        dateSelect(date) {
            this.trendTime = [...date];
        },
        initTableData(data) {
            this.trendTableData = [];
            this.page = data.page;
            this.page_size = data.page_size;
            for(let i=(data.page_size * (data.page - 1)); i<this.trendData.length; i++) {
                this.trendTableData.push(this.trendData[i]);
                if(this.trendTableData.length == data.page_size) break;
            }
        },
        initEcharts() {
            var lineChart = this.echarts.init(this.$refs.line_echart);
            lineChart.resize();
        },
        initLine() {
            let xData = [], yData = [];
            this.trendData.forEach(item => {
                xData.push(item.time_info);
                yData.push(item[this.trendType]);
            })
            xData.reverse();
            yData.reverse();
            var lineChart = this.echarts.init(this.$refs.line_echart);
            lineChart.clear();
            lineChart.setOption(this.lineOption(xData, yData));
        },
        lineOption(xData, yData) {
            return {
                grid: this.$store.state.type == 'pc' ? {
                    left: 20,
                    top: 40,
                    bottom: 10,
                    right: 40,
                    containLabel: true
                } :  {
                    left: 20,
                    top: 40,
                    bottom: 10,
                    right: 20,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData,
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: (item, index) => {
                            if(this.$store.state.type == 'pc') {
                                return item.split('~')[item.split('~').length - 1];
                            }else{
                                return item.split('~')[item.split('~').length - 1].substr(5);
                            }
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    splitNumber: 5,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function(value, index) {
                            if(value/1000000 >= 1) {
                                return value/1000000 + 'M';
                            }else if(value/1000 >= 1) {
                               return value/1000 + 'K';
                            }
                            return value;
                        }
                    }
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    backgroundColor: 'rgba(255,255,255,.9)',
                    orderWidth: 0,
                    textStyle: {
                        color: '#333'
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            type: 'solid',
                            color: 'rgba(200,200,200,.4)'
                        }
                    },
                    formatter: (n) => {
                        return `${n[0].name} <br /> ${this.trendLabel[this.trendType]}: ${this.formatNumber(n[0].value)}`;
                    }

                },
                dataZoom: this.$store.state.type == 'pc' ? null : {
                    type: 'inside',
                    start: 0,
                    end: 100
                },
                series: [
                    {
                        data: yData,
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        lineStyle: {
                            color: '#5192FF',
                            width: 1
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y:1,
                                x2: 0,
                                y2: 0,
                                colorStops: [{
                                    offset: 0, color: '#FFFFFF' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#507FF7' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        }
                    }
                ]
            }
        }
    }
})
</script>
<style lang="less" scoped>
    @import '../../../less/statistics.less';
    .content{
        .overview{
            .icon-tip{
                margin-right: 20px;
            }
            .overview_box{
                color: #333;
                display: block;
                .overview_area{
                    .flexLayout(space-around, flex-start);
                    margin-top: 50px;
                    padding-bottom: 40px;
                    .online{
                        color: #507FF7;
                    }
                    &:first-child{
                        border-bottom: 1px solid #E8E9F1;
                    }
                    &.overview_area_1{
                        justify-content: space-between;
                        margin-top: 20px;
                        margin-bottom: 0;
                        padding-bottom: 0;
                        & > div {
                            border-radius: 12px;
                            background-color: #EDF5FD;
                            width: 30%;
                            font-size: 14px;
                            font-weight: 600;
                            .overview_title{
                                color: #507FF7;
                                text-align: center;
                                line-height: 50px;
                                border: 1px solid #fff;
                            }
                            .overview_item{
                                padding: 0 20px;
                                line-height: 60px;
                                border: 1px solid #fff;
                                .flexLayout(space-between);
                                .name{
                                    font-weight: 500;
                                }
                                .number{
                                    font-size: 18px;
                                    margin: 0;
                                }
                            }
                            &.device_area_2{
                                background-color: #FBF4E9;
                                .overview_title{
                                    color: @colorY;
                                }
                            }
                            &.device_area_3{
                                background-color: #EBF7F5;
                                .overview_title{
                                    color: #00D6B9;
                                    
                                }
                            }
                        }
                    }
                }
                
            }
        }
    }
    @media (max-width: 768px) {
        .mobile_content {
            .top{
                .title{
                    margin-bottom: 20px;
                }
            }
            .area{
                height: calc(100% - 116px);
            }
            .content{
                .overview{
                    .title{
                        justify-content: space-between;
                        /deep/ .el-select{
                            width: 150px;
                            .el-input__inner{
                                min-width: 150px!important;
                                line-height: 28px;
                                height: 28px;
                                background: none;
                            }
                        }
                    }
                    .overview_box{
                        background: none;
                        padding: 0;
                        .overview_area{
                            padding: 15px 20px;
                            margin-top: 20px;
                            background: #fff;
                            border-radius: 9px;
                            .overview_item{
                                width: 48%;
                                text-align: left;
                                margin-bottom: 30px;
                                .number{
                                    font-size: 18px;
                                    margin: 10px 0;
                                }
                                .compared{
                                    justify-content: flex-start;
                                }
                                &:nth-child(1){
                                    margin-bottom: 30px;
                                }
                            }
                            &.overview_area_1{
                                padding: 0;
                                background: none;
                                flex-wrap: wrap;
                                
                                > div{
                                    width: 100%;
                                    margin-bottom: 20px;
                                }
                                .device_area_1{
                                    background-color: #E0EFFF;
                                }
                                .device_area_2{
                                    background-color: #FBEFE0;
                                }
                                .device_area_3{
                                    background-color: #DFF3F0;
                                    margin-bottom: 0;
                                }
                                .overview_item{
                                    width: 100%;
                                    box-sizing: border-box;
                                    border: none;
                                    border-top: 1px solid #fff;
                                    margin: 0;
                                }
                            }
                        }
                        
                    }
                }
                .trend{
                    .trend_box{
                        background-color: #fff;
                    }
                }
            }
        }
            
    }
</style>



// WEBPACK FOOTER //
// src/view/statistics/device/device-operation.vue